import {
  SchedulerDependencyEntryViewModel
} from './MediaDependencyEntryViewModel';

export class ResolveActionResult {
  public get isSuccess(): boolean {
    return this.resultMessage === 'Success!';
  }

  constructor(
    public dependency: SchedulerDependencyEntryViewModel,
    public resultMessage: string
  ) {
  }
}
